import React from 'react';

import logoMini from 'assets/img/brand/logo_mini.png';
import { Link } from 'react-router-dom';

const NavbarGuide = () => {
  return (
    <div className='navbar'>
      <div>
        <Link to='/'>
          <img alt='logo-nav' className='logo' src={logoMini} />
        </Link>
        <span className='title'>Docs</span>
      </div>
    </div>
  );
};
export default NavbarGuide;
